import React, { useContext, useEffect, useState } from "react"
import { OffersContext } from "../../context/offers/OffersContext"
import Offer from "../../components/offers/Offer";
import { Link, useParams } from "react-router-dom";
import { LanguageContext } from "../../context/language/LanguageContext";
import { GoogleMap, InfoWindow, Marker, useJsApiLoader } from "@react-google-maps/api";


export default function GMap({ locations }) {

    console.log(JSON.parse(localStorage.getItem("l")))
    const { languageid, languagecode } = JSON.parse(localStorage.getItem("l"))
    //localStorage.getItem("l")
    //     ? JSON.parse(localStorage.getItem("l"))
    //     : { languageid: 529, languagecode: "ja", languagename: "Japanese" };


    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: process.env.REACT_APP_GOOGLEMAPAPIKEY,
        language: languagecode,
    });




    const [map, setMap] = useState(null);
    const [mapCenter, setMapCenter] = useState(null);
    const [isLocSelected, setisLocSelected] = useState();
    const [locInfo, setLocInfo] = useState(null);
    const onUnmount = React.useCallback(function callback(map) {
        setMap(null);
    }, []);

    const selectStore = (e) => {
        e.preventDefault();

        let element;
        if (
            e.target.classList.lenght > 0 &&
            e.target.classList.indexOf("locationdiv") > -1
        ) {
            element = e.target;
        } else {
            element = e.target.closest(".locationdiv");
        }

        let sibling = element.parentNode.firstChild;

        // collecting siblings
        while (sibling) {
            if (sibling.nodeType === 1 && sibling !== e) {
                sibling.classList.remove("ow-primary-blue");
            }
            sibling = sibling.nextSibling;
        }
        element.classList.add("ow-primary-blue");
        setMapCenter(JSON.parse(element.getAttribute("location")));
        setLocInfo(JSON.parse(element.getAttribute("nameandaddress")));
    };


    const [locationsFiltered, setLocationsFiltered] = useState();
    useEffect(() => {
        setLocationsFiltered(locations)
        if (locations?.length > 0) {
            setMapCenter({
                lat: locations[0].latitude,
                lng: locations[0].longitude,
            });
            setLocInfo({
                name: locations[0].name,
                address: locations[0].address,
            });
        }
    }, [locations])

    const filterLocations = (e) => {
        // console.log("val : ", e.target.value);

        const filtered = locations.filter((storeLoc) => {
            return storeLoc.name.toLowerCase().includes(e.target.value.toLowerCase())
        })

        setLocationsFiltered(filtered)

    }


    return <div className="row h-100">
        <div className="col-md-4 border-end h-100 overflow-hidden">
            <div>
                <input type="text" class="form-control mb-2" id="txtFilterLocations" placeholder="Search..."
                    onChange={filterLocations} />
            </div>
            <div className="overflow-y-auto h-100">
                {locations?.length > 0
                    ? locationsFiltered?.map((loc, index) => {
                        const selectedloc = index === 0 ? "ow-primary-blue" : "";
                        return (
                            <div
                                className={`position-relative p-3 pt-3 pb-3 border-bottom locationdiv ${selectedloc}`}
                                key={index}
                                location={JSON.stringify({
                                    lat: loc.latitude,
                                    lng: loc.longitude,
                                })}
                                nameandaddress={JSON.stringify({
                                    name: loc.name,
                                    address: loc.address,
                                })}
                                onClick={(e) => selectStore(e)}
                            >
                                <i class="bi bi-geo-alt-fill mt-1 pt-3 position-absolute top-0"></i>
                                <div className="ms-4 me-4">
                                    <p className="fw-bold">{loc.name}</p>
                                    <p>{loc.address}</p>
                                </div>
                                <i
                                    class="bi bi-arrow-right position-absolute top-50"
                                    style={{ right: "10px" }}
                                ></i>
                            </div>
                        );
                    })
                    : ""
                }
            </div>
        </div>
        <div className="col-md-8 mt-5 mt-md-auto">
            {locations?.length > 0 && isLoaded ? (
                <GoogleMap
                    mapContainerStyle={{
                        width: "100%",
                        height: "100%",
                    }}
                    center={mapCenter}
                    zoom={15}
                    // onLoad={onLoad}
                    onUnmount={onUnmount}
                >
                    {locationsFiltered?.map((loc) => {
                        return (
                            <Marker
                                position={{ lat: loc.latitude, lng: loc.longitude }}
                            >

                            </Marker>
                        );
                    })}
                    {/* Child components, such as markers, info windows, etc. */}

                    {mapCenter && (
                        <InfoWindow position={mapCenter}>
                            <div className="">
                                <p className="fw-bold">{locInfo.name}</p>
                                <p>{locInfo.address}</p>
                            </div>
                        </InfoWindow>
                    )}
                </GoogleMap>
            ) : (
                <></>
            )}
        </div>
    </div>
}